/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreGtaRequest
 */
export interface StoreGtaRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreGtaRequest
     */
    gta_group: string;
    /**
     * 
     * @type {string}
     * @memberof StoreGtaRequest
     */
    status: StoreGtaRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreGtaRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreGtaRequest
     */
    gta_sort_index?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreGtaRequest
     */
    daily_hire_rate: number;
}


/**
 * @export
 */
export const StoreGtaRequestStatusEnum = {
    Active: 'ACTIVE',
    Deleted: 'DELETED'
} as const;
export type StoreGtaRequestStatusEnum = typeof StoreGtaRequestStatusEnum[keyof typeof StoreGtaRequestStatusEnum];


/**
 * Check if a given object implements the StoreGtaRequest interface.
 */
export function instanceOfStoreGtaRequest(value: object): value is StoreGtaRequest {
    if (!('gta_group' in value) || value['gta_group'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('daily_hire_rate' in value) || value['daily_hire_rate'] === undefined) return false;
    return true;
}

export function StoreGtaRequestFromJSON(json: any): StoreGtaRequest {
    return StoreGtaRequestFromJSONTyped(json, false);
}

export function StoreGtaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreGtaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'gta_group': json['gta_group'],
        'status': json['status'],
        'description': json['description'] == null ? undefined : json['description'],
        'gta_sort_index': json['gta_sort_index'] == null ? undefined : json['gta_sort_index'],
        'daily_hire_rate': json['daily_hire_rate'],
    };
}

export function StoreGtaRequestToJSON(json: any): StoreGtaRequest {
    return StoreGtaRequestToJSONTyped(json, false);
}

export function StoreGtaRequestToJSONTyped(value?: StoreGtaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gta_group': value['gta_group'],
        'status': value['status'],
        'description': value['description'],
        'gta_sort_index': value['gta_sort_index'],
        'daily_hire_rate': value['daily_hire_rate'],
    };
}

